<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar
        color="transparent"
        class="elevation-0 pa-0 page-header-toolbar"
      >
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.first_name"
                  v-validate="'required|max:50'"
                  :label="$t('persons.first_name')"
                  :error-messages="errors.collect('person.first_name')"
                  data-vv-name="person.first_name"
                  autocomplete="off"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.middle_name"
                  v-validate="'max:50'"
                  :label="$t('persons.middle_name')"
                  :error-messages="errors.collect('person.middle_name')"
                  data-vv-name="person.middle_name"
                  autocomplete="off"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.last_name"
                  v-validate="'required|max:50'"
                  :label="$t('persons.last_name')"
                  :error-messages="errors.collect('person.last_name')"
                  data-vv-name="person.last_name"
                  autocomplete="off"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.mobile"
                  v-validate="'required|max:20|no_space'"
                  :label="$t('persons.mobile')"
                  :error-messages="errors.collect('person.mobile')"
                  data-vv-name="person.mobile"
                  name="person.mobile"
                  @blur="phoneNoSpace"
                  autocomplete="off"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="user.email"
                  :label="$t('persons.email')"
                  v-validate="'required|email|max:255'"
                  :error-messages="errors.collect('person.email')"
                  data-vv-name="person.email"
                  autocomplete="off"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="person.organisation_id"
                  v-model="person.organisation_id"
                  :items="organisations"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.title')"
                  autocomplete="off"
                  :error-messages="errors.collect('person.organisation_id')"
                  @change="
                    checkOrganisationIfSystemOwner(person.organisation_id)
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="show_create_user">
                <v-checkbox
                  name="person.created_as_user"
                  v-model="person.created_as_user"
                  :label="$t('persons.create_as_user')"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="person.comments"
                  v-model="person.comments"
                  :label="$t('persons.comments')"
                  :error-messages="errors.collect('person.comments')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

import axios from "axios"

export default {
  components: { ActionButton },
  name: "PersonForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      user: {},
      person: {},
      organisations: [],
      show_create_user: false,
      dictionary: {
        attributes: {
          "person.first_name": this.$t("persons.first_name"),
          "person.middle_name": this.$t("persons.middle_name"),
          "person.last_name": this.$t("persons.last_name"),
          "person.email": this.$t("persons.email"),
          "person.mobile": this.$t("persons.mobile"),
          "person.comments": this.$t("persons.comments"),
        },
      },
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid)
    },
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    axios.get(this.API_URL + "organisations?show_all").then(res => {
      this.organisations = res.data.data

      if (!this.id) {
        this.page_title = this.$t("persons.new_person")
        this.person = {}
      } else {
        axios
          .get(this.API_URL + "person/" + this.id)
          .then(res => {
            this.person = res.data.data
            this.user = res.data.data.user
            this.checkOrganisationIfSystemOwner(this.person.organisation_id)

            this.page_title = this.$t("persons.edit_person", {
              name: this.person.first_name + " " + this.person.last_name,
            })
          })
          .catch(err => console.log(err))
      }
    })
  },

  methods: {
    checkOrganisationIfSystemOwner(id) {
      let org = this.organisations.find(i => i.id == id && i.owner == 1)
      this.show_create_user = org ? true : false

      if (!this.show_create_user) {
        this.person.created_as_user = false
      }
    },

    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.id) {
              // Create
              axios
                .post(this.API_URL + "person", {
                  organisation_id: vm.person.organisation_id,
                  first_name: vm.person.first_name,
                  last_name: vm.person.last_name,
                  middle_name: vm.person.middle_name,
                  email: vm.user.email,
                  mobile: vm.person.mobile,
                  comments: vm.person.comments,
                  created_as_user: vm.person.created_as_user,
                })
                .then(() => {
                  vm.$router.push(vm.BACKEND_URL + "/persons")
                  vm.$awn.success(vm.$t("global.create_success"))
                  vm.$router
                    .replace(this.BACKEND_URL + `/persons/edit/${vm.person.id}`)
                    .catch(() => {})
                })
                .catch(err => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "person", {
                  id: vm.person.id,
                  organisation_id: vm.person.organisation_id,
                  first_name: vm.person.first_name,
                  last_name: vm.person.last_name,
                  middle_name: vm.person.middle_name,
                  email: vm.user.email,
                  mobile: vm.person.mobile,
                  comments: vm.person.comments,
                  created_as_user: vm.person.created_as_user,
                })
                .then(() => {
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch(err => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    phoneNoSpace() {
      if (this.person.mobile) {
        this.person.mobile = this.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find(
          i => i.field == "person.mobile" && i.rule == "no_space",
        )
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
  },
}
</script>

<style scoped></style>
